// Theme definitions with varying rarity and style
export const themes = {
    default: {
        name: 'Default',
        colors: {
            primary: '#fafafa',
            secondary: '#c8c8c8ff',
            accent: '#121212',
            text: '#000000',
            overlay: 'rgba(255, 255, 255, 0.7)',
            background: '#dbdbdb',
        }
    },
    mintGreen: {
        name: 'Mint Green',
        colors: {
            primary: '#98FF98',
            secondary: '#90EE90',
            accent: '#3CB371',
            text: '#006400',
            overlays: 'rgba(230,255,230,0.7)',
            background: '#F0FFF0'
        }
    },
    summerHaze: {
        name: 'Summer Haze',
        colors: {
            primary: '#FFB6C1',
            secondary: '#FFA07A',
            accent: '#FF8C00',
            text: '#8B4513',
            overlays: 'rgba(255, 239, 230, 0.7)',
            background: '#ff4281ff'
        }
    },
    rainbowBerry: {
        name: 'Rainbow Berry',
        colors: {
            primary: '#FF69B4',
            secondary: '#9370DB',
            accent: '#4B0082',
            text: '#2F4F4F',
            overlays: 'rgba(255, 230, 248, 0.7)',
            background: 'linear-gradient(45deg, #FF69B4, #9370DB, #4B0082)'
        }
    },
    neonNights: {
        name: 'Neon Nights',
        colors: {
            primary: '#00FF00',
            secondary: '#FF00FF',
            accent: '#00FFFF',
            text: '#FFFFFF',
            overlays: 'rgba(230, 233, 255, 0.7)',
            background: 'linear-gradient(180deg, #000000, #1a1a1a)',
            glow: '0 0 10px #00FF00'
        }
    },
    galaxyDreams: {
        name: 'Galaxy Dreams',
        colors: {
            primary: '#8A2BE2',
            secondary: '#4B0082',
            accent: '#9400D3',
            text: '#E6E6FA',
            overlays: 'rgba(243, 230, 255, 0.7)',
            background: 'url(\'https://i.ebayimg.com/images/g/n8IAAOSwltRkNCSF/s-l1200.webp\')',
            glow: '',
            particles: true
        }
    }
};


// Theme management functions
export const themeManager = {
    currentTheme: 'rainbowBerry',
    // Get current theme object
    getCurrentTheme() {
        return themes[this.currentTheme] || themes.rainbowBerry;
    },

    // Set current theme if user owns it
    setTheme(themeName) {
        if (themes[themeName]) {
            // TODO: Add check for theme ownership here
            this.currentTheme = themeName;
            return true;
        }
        return false;
    },

    // Get list of all available themes
    getAllThemes() {
        return Object.entries(themes).map(([id, theme]) => ({
            id,
            ...theme
        }));
    },

    // Get list of themes owned by user
    getOwnedThemes() {
        // TODO: Implement actual ownership check with backend
        return this.getAllThemes(); // For testing purposes
    }
};